module.exports = __webpack_public_path__ + "img/mango.985a835f.png";